import { render } from "./Documenti.vue?vue&type=template&id=4e945670&scoped=true&ts=true"
import script from "./Documenti.vue?vue&type=script&lang=ts"
export * from "./Documenti.vue?vue&type=script&lang=ts"

import "./Documenti.vue?vue&type=style&index=0&id=4e945670&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e945670"]])

export default __exports__